import { ReportYears } from 'src/store/baseUrl/baseUrlStore.types';
import {
  DropDownItems,
  DropDownItemsRegion,
  DropDownItemsStoreType,
} from 'src/store/dropDown/dropDownItemsStore.types';
import { API_BASE_URL } from 'src/services/envVariableLoader';
import { getSortInfo } from './languageSpanHelpers';

const getQuery = (reportYears: ReportYears): string => {
  if (reportYears) {
    return (
      '?' +
      Object.entries(reportYears)
        .map(([key, value]: [key: string, value: string | number]) => {
          if (key === 'typeOfProjectPartner')
            return encodeURIComponent('type') + '=' + encodeURIComponent(value);
          return encodeURIComponent(key) + '=' + encodeURIComponent(value);
        })
        .join('&')
    );
  }
  return '';
};

export const getRegion = async (
  language: string,
  reportYears: ReportYears
): Promise<DropDownItemsRegion[]> => {
  const response = await fetch(
    `${API_BASE_URL}/projects/${language}/regions${getQuery(reportYears)}`
  );
  if (!response.ok) {
    throw new Error('Error happened');
  }
  const data: DropDownItemsRegion[] = await response.json();
  return data;
};

export const getCountry = async (
  language: string,
  reportYears: ReportYears
): Promise<DropDownItems[]> => {
  const response = await fetch(
    `${API_BASE_URL}/projects/${language}/countries${getQuery(reportYears)}`
  );
  if (!response.ok) {
    throw new Error('Error happened');
  }
  const data: DropDownItems[] = await response.json();
  return data;
};

export const getSector = async (
  language: string,
  reportYears: ReportYears
): Promise<DropDownItems[]> => {
  const response = await fetch(
    `${API_BASE_URL}/projects/${language}/sectors${getQuery(reportYears)}`
  );
  if (!response.ok) {
    throw new Error('Error happened');
  }
  const data: DropDownItems[] = await response.json();
  return data;
};

export const getSector2 = async (
  language: string,
  reportYears: ReportYears
): Promise<DropDownItems[]> => {
  const response = await fetch(
    `${API_BASE_URL}/projects/${language}/sectors2${getQuery(reportYears)}`
  );
  if (!response.ok) {
    throw new Error('Error happened');
  }
  const data: DropDownItems[] = await response.json();
  return data;
};

export const getTypeOfProjectPartner = async (
  language: string,
  reportYears: ReportYears
): Promise<DropDownItems[]> => {
  const response = await fetch(
    `${API_BASE_URL}/projects/${language}/carrierTypes${getQuery(reportYears)}`
  );
  if (!response.ok) {
    throw new Error('Error happened');
  }
  const data: DropDownItems[] = await response.json();
  return data;
};

export const getDropDownItems = async (
  language: string,
  reportYears: ReportYears
): Promise<DropDownItemsStoreType> => {
  return await Promise.allSettled([
    getRegion(language, reportYears),
    getCountry(language, reportYears),
    getSector(language, reportYears),
    getSector2(language, reportYears),
    getTypeOfProjectPartner(language, reportYears),
  ]).then(values => {
    const results: DropDownItemsStoreType = {
      region:
        values[0].status === 'fulfilled'
          ? values[0].value.sort((a, b) =>
              getSortInfo(a.value, b.value, language)
            )
          : [],
      country:
        values[1].status === 'fulfilled'
          ? values[1].value.sort((a, b) =>
              getSortInfo(a.value, b.value, language)
            )
          : [],
      sector:
        values[2].status === 'fulfilled'
          ? values[2].value.sort((a, b) =>
              getSortInfo(a.value, b.value, language)
            )
          : [],
      sector2:
        values[3].status === 'fulfilled'
          ? values[3].value.sort((a, b) =>
              getSortInfo(a.value, b.value, language)
            )
          : [],
      typeOfProjectPartner:
        values[4].status === 'fulfilled'
          ? values[4].value.sort((a, b) =>
              getSortInfo(a.value, b.value, language)
            )
          : [],
    };

    return results;
  });
};
